// --------------------------------------------------------------------------
// Check password passes validation as you type
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function checkLength(string) {
        var $tickedEl = context.find('[data-binding="checkcount"]');

        if (string.length >= 8) {
            $tickedEl.addClass('check-password__rules__list__tick');
        } else {
            $tickedEl.removeClass('check-password__rules__list__tick');
        }
    }

    function checkCap(string) {
        var $tickedEl = context.find('[data-binding="checkupper"]');

        if (/[A-Z]/.test(string)) {
            $tickedEl.addClass('check-password__rules__list__tick');
        } else {
            $tickedEl.removeClass('check-password__rules__list__tick');
        }
    }

    function checkLower(string) {
        var $tickedEl = context.find('[data-binding="checklower"]');

        if (/[a-z]/.test(string)) {
            $tickedEl.addClass('check-password__rules__list__tick');
        } else {
            $tickedEl.removeClass('check-password__rules__list__tick');
        }
    }

    function checkNo(string) {
        var $tickedEl = context.find('[data-binding="checknumber"]');

        if (/[0-9]/.test(string)) {
            $tickedEl.addClass('check-password__rules__list__tick');
        } else {
            $tickedEl.removeClass('check-password__rules__list__tick');
        }
    }

    function init() {
        var value;

        context.find('[type="password"]').on('keyup', function () {
            value = $(this).val();

            checkLength(value);
            checkLower(value);
            checkCap(value);
            checkNo(value);
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/check-password.js
// module id = 514
// module chunks = 0